import React from 'react'
import { Control, Controller, ControllerRenderProps } from 'react-hook-form'
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
} from '@material-ui/core'

type Option = {
  label: string
  value: string
}

type Props<T> = RadioGroupProps & {
  control: Control
  name: string
  options: Option[]
  defaultValue?: T
}

export function ControlledRadioGroup<T>(props: Props<T>): React.ReactElement {
  const {
    control,
    name,
    options,
    defaultValue,
    onChange,
    row,
    ...radioGroupProps
  } = props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? false}
      render={({
        value,
        onChange: controllerOnChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: T }) => (
        <RadioGroup
          row={row === undefined ? true : row}
          {...radioGroupProps}
          value={value}
          onChange={(event, newValue) => {
            controllerOnChange(newValue)

            if (onChange) {
              onChange(event, newValue)
            }
          }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              control={<Radio />}
              label={option.label}
              value={option.value}
            />
          ))}
        </RadioGroup>
      )}
    />
  )
}
